export default __webpack_public_path__ + "static/media/BOProto2.70550456.png";